export default __webpack_public_path__ + "static/media/html-5.1833c6f8.svg";